// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__37qp4","title":"Info_title__T76Nj","selects":"Info_selects__5N8SH","requiredAsterisk":"Info_requiredAsterisk__2nLdh"};